import React, { useEffect, useState } from 'react';
import MetadataInput from './metadata_input';
const arrayIncludes = (element, inputArray) => {
    if (!inputArray)
        return false;
    if ((inputArray === null || inputArray === void 0 ? void 0 : inputArray[0]) === '*')
        return true;
    return inputArray === null || inputArray === void 0 ? void 0 : inputArray.some(el => el.localeCompare(element, undefined, { sensitivity: 'accent' }) === 0);
};
const MetadataForm = (props) => {
    const { orgMetadata, metadata, handleFormChange, twoColumns, requiredFields, optionalFields, updateRequiredErrors, fieldsToRender, } = props;
    const [requiredErrors, setRequiredErrors] = useState([]);
    const isRenderableFieldName = (name) => {
        return !(fieldsToRender === null || fieldsToRender === void 0 ? void 0 : fieldsToRender.length) || arrayIncludes(name, fieldsToRender);
    };
    const isRequiredFieldName = (name) => {
        return !arrayIncludes(name, optionalFields) && arrayIncludes(name, requiredFields);
    };
    const hasRequiredError = (name) => {
        return !arrayIncludes(name, optionalFields) && arrayIncludes(name, requiredErrors);
    };
    useEffect(() => {
        if (updateRequiredErrors) {
            updateRequiredErrors(requiredErrors);
        }
    }, [requiredErrors]);
    useEffect(() => {
        if (metadata) {
            const hasRequiredErrors = metadata.reduce((missingRequiredFields, metadataField) => {
                if (isRequiredFieldName(metadataField.name)) {
                    if (typeof metadataField.value !== 'boolean' && !metadataField.value) {
                        missingRequiredFields.push(metadataField.name);
                    }
                    if (metadataField.value instanceof Array && metadataField.value.length === 0) {
                        missingRequiredFields.push(metadataField.name);
                    }
                }
                return missingRequiredFields;
            }, []);
            setRequiredErrors(hasRequiredErrors);
            if (updateRequiredErrors) {
                updateRequiredErrors(hasRequiredErrors);
            }
        }
    }, [metadata]);
    if (twoColumns === true) {
        const formColumns = [...Array(2).keys()].map(col => orgMetadata.filter((_, i) => i % 2 === col));
        const formColumnsMap = formColumns.map((data, index) => {
            return React.createElement("div", { key: `edit-column-${index}`, className: 'form-column' }, data.map(orgMetadataField => isRenderableFieldName(orgMetadataField.name) &&
                React.createElement(MetadataInput, { key: `input-${orgMetadataField.name}`, required: isRequiredFieldName(orgMetadataField.name), isOptional: arrayIncludes(orgMetadataField.name, optionalFields), hasRequiredError: hasRequiredError(orgMetadataField.name), orgMetadataField: Object.assign({}, orgMetadataField), onChange: handleFormChange, metadata: metadata })));
        });
        return (React.createElement(React.Fragment, null, formColumnsMap));
    }
    const fieldMap = orgMetadata.map(orgMetadataField => isRenderableFieldName(orgMetadataField.name) &&
        React.createElement(MetadataInput, { key: `input-${orgMetadataField.name}`, required: isRequiredFieldName(orgMetadataField.name), isOptional: arrayIncludes(orgMetadataField.name, optionalFields), hasRequiredError: hasRequiredError(orgMetadataField.name), orgMetadataField: Object.assign({}, orgMetadataField), onChange: handleFormChange, metadata: metadata }));
    return (React.createElement(React.Fragment, null, fieldMap));
};
export default MetadataForm;
